import * as Type from './ProductActionTypes';
import * as productServices from '../../../services/product/productServices';
export function loadProductAction(product,id){
    return {
        type:Type.READ_PRODUCT, 
        payload:{product,id}
    };
}
// export const createProductAction = (title,description,type,qty,date) => async(dispatch)=>{
//     try{
//         const res = await productServices.create({title,description,type,qty,date});
//         dispatch({
//             type: Type.CREATE_PRODUCT, //Action Type
//             payload:res.data  //Payload ~ Data
//         });
//         return Promise.resolve(res.data);
//     }catch(error){
//         return Promise.reject(error);
//     }    
// };


export function loadProductSuccess(product){
    return { 
        type:Type.LOAD_PRODUCT_SUCCESS, 
        payload:product
    };
}




export const getByQuantityAction = ( qty) => {
    return { 
        type: Type.GET_PRODUCT_BY_QUANTITY, 
        payload: qty 
    };
};



/*
export function loadProducts(){
    
    return function(dispatch){
        return productServices.getProducts()
            .then(product =>{
                dispatch(loadProductSuccess(product));
            }).catch(error =>{
                throw error;
            });
    };
}
*/

export const readProduct = (id = 0) => {
    console.log('readProduct called with id', id);
    return (dispatch) => {
        if (id === 0) {
            return productServices.getAllProducts()
                .then((products) => {
                    dispatch(loadProductAction(products, id));
                })
                .catch((error) => console.log('Error:', error));
        }else {
            return productServices.get(id)
                .then((products) => {
                    dispatch(loadProductAction(products, id));
                })
                .catch((error) => console.log('Error:', error));
        }
    };
};


export const createUpdateProduct = (product) => {
    return (dispatch) => {
        console.log('inside createUpdateProduct', product);
        if (product.productId === null) {
            return productServices.create(product)
                .then((product) => {
                    dispatch(createProductAction(product));
                })
                .catch((error) => console.log('Error:', error));
        } else {
            return productServices.update(product.id,product)
                .then((product) => {
                    dispatch(updateProductAction(product.id,product));
                })
                .catch((error) => console.log('Error:', error));
        }
    };
};






// Create Product 
export const createProductAction = (products) => {
    return { type: Type.CREATE_PRODUCT, payload: { products} };
};
export const createProduct = (product) => {
    return (dispatch) => {
        console.log('inside create Product', product);
        return productServices.create(product)
            .then((product) => {
                dispatch(createProductAction(product));
            })
            .catch((error) => console.log('Error:', error));
    };
};

// Show ALL Products

export const getAllProductAction = (products, id) => {
    return { type: Type.LOAD_PRODUCT_SUCCESS, payload: { products,id} };
};
export const getAllProducts = () => {
    console.log('get products called ');
    return async (dispatch) => {
        try {
            const products = await productServices.getAllProducts();
            dispatch(getAllProductAction(products));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};

// Delete Product
export const deleteProductAction = (product_id) => {
    return { type: Type.DELETE_PRODUCT, payload: { product_id} };
};
export const deleteProduct = (product_id = 0) => {
    console.log('inside deleteproduct',product_id);
    return (dispatch) => {
        return productServices.remove(product_id)
            .then(() => {
                dispatch(deleteProductAction(product_id));
            })
            .catch((error) => console.log('Error:', error));
    };
};

// Update Product
export const updateProductAction = (product, id) => {
    return { 
        type: Type.UPDATE_PRODUCT, 
        payload: {product,id} 
    };
};
export const updateProduct = (product_id = 0,product) => {
    return (dispatch) => {
        console.log('inside createUpdateProduct', product, product_id);
        return productServices.update(product_id,product)
            .then((product,product_id) => {
                dispatch(updateProductAction(product,product_id));
            })
            .catch((error) => console.log('Error:', error));
    };
};


//get Product By Product Id

export const getProductById = (product_id = 0) => {
    console.log('get products By product id', product_id);
    return async (dispatch) => {
        try {
            const products = await productServices.get(product_id);
            dispatch(getAllProductAction(products,product_id));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};

// get Product By Name
export const getAllProductByNameAction = (products, name) => {
    return { type: Type.LOAD_PRODUCT_SUCCESS, payload: { products,name} };
};
export const getProductByName = (product_Name = null) => {
    console.log('get products By product id', product_Name);
    return async (dispatch) => {
        try {
            const products = await productServices.getByName(product_Name);
            dispatch(getAllProductByNameAction(products,product_Name));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};
